import { render } from "./OcCopyContent.vue?vue&type=template&id=02caa88e&scoped=true"
import script from "./OcCopyContent.vue?vue&type=script&lang=js"
export * from "./OcCopyContent.vue?vue&type=script&lang=js"

import "./OcCopyContent.vue?vue&type=style&index=0&id=02caa88e&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02caa88e"]])

export default __exports__